import {ACCIDENT_PARTIES_AT_FAULT_OPTIONS, ACCIDENT_TYPE_OPTIONS, YES_NO_CHOICE_OPTIONS} from "@constants/dropdown-choices";
import DynamicItemHeadingComponent from "@components/common/ui-elements/headings/dynamic-item-heading";
import ScrollableButtonGroupBlock from "@components/common/form-blocks/scrollable/button-group-block";
import ScrollableCustomDateTimePickerBlock
    from "@components/common/form-blocks/scrollable/custom-datetime-picker-block";
import ScrollableTextBoxBlock from "@components/common/form-blocks/scrollable/text-box-block";
import ScrollableDropdownBlock from "@components/common/form-blocks/scrollable/dropdown-block";

export default function AdditionalDriverAccidentForm(
    {
        accident,
        driverIndex,
        accidentIndex,
        motorAccidentsListPropName,
        handleAdditionalDriverAccidentPropChange ,
        addAdditionalDriverAccident ,
        removeAdditionalDriverAccident,
    }
) {

    const generateName = (prop) => {
        return `${motorAccidentsListPropName}[${accidentIndex}][${prop}]`;
    }

    const generateDataBlockName = (prop) => {
        return `${motorAccidentsListPropName}.${accidentIndex}.${prop}`;
    }

    const generateIdPrefix = (prop) => {
        return `${motorAccidentsListPropName}-${accidentIndex}-${prop}-`;
    }

    return (
        <div className="policy-holder-accident-block hidden-box row">

            <DynamicItemHeadingComponent
                text="Accident"
                itemIndex={accidentIndex + 1}
                onRemoveIconClick={(e) => removeAdditionalDriverAccident(driverIndex,accidentIndex)}
            />

            {/*<ScrollableButtonGroupBlock
                containerCssClass="col-12 py-3 "
                labelText="Was a valid insurance policy in force at the time of accident?"
                required={true}
                controlName={generateName('hadActiveInsurance')}
                options={YES_NO_CHOICE_OPTIONS}
                selectedValues={accident.hadActiveInsurance}
                onChange={(e) => handleAdditionalDriverAccidentPropChange(accidentIndex, 'hadActiveInsurance', e.target.value)}
                btnGroupAttrs={{
                    className: 'btn-group vertical-mobile'
                }}
            />*/}

            {/* What type of incident was it? */}

            <ScrollableButtonGroupBlock
                containerCssClass="col-12 py-3 "
                labelText="What type of incident was it?"
                required={true}
                controlName={generateName('type')}
                options={ACCIDENT_TYPE_OPTIONS}
                selectedValues={accident.type}
                dataBlock={generateDataBlockName('type')}

                onChange={(e) => handleAdditionalDriverAccidentPropChange(driverIndex, accidentIndex, 'type', e.target.value)}
                btnGroupAttrs={{
                    className: 'btn-group vertical-mobile'
                }}
            />



            {/* Date */}

            <ScrollableCustomDateTimePickerBlock
                containerCssClass="col-12 py-3 col-md-6"
                labelText="Date"
                required={true}
                controlName={generateName('date')}
                dataBlock={generateDataBlockName('date')}
                value={accident.date}
                onChange={(e) => handleAdditionalDriverAccidentPropChange(driverIndex, accidentIndex, 'date', e.target.value)}

            />



            {/* Who is at fault? */}

            <ScrollableDropdownBlock
                controlName={generateName('partyAtFault')}
                dataBlock={generateDataBlockName('partyAtFault')}
                containerCssClass="col-12 py-3 col-md-6"
                labelText="Who is at fault?"
                required={true}
                options={ACCIDENT_PARTIES_AT_FAULT_OPTIONS}
                selectedValues={accident.partyAtFault}
                onChange={(e) => handleAdditionalDriverAccidentPropChange(driverIndex, accidentIndex, 'partyAtFault', e.target.value)}
                helpText=""
            />
           
           
           
           {/* Has the accident been settled? */}
           
           <ScrollableButtonGroupBlock
              selectedValues={accident.wasAccidentSettled}
              containerCssClass="col-12 py-3"
              labelText="Has the accident been settled?"
              required={true}
              controlName={generateName('wasAccidentSettled')}
              options={YES_NO_CHOICE_OPTIONS}
              
              onChange={(e) => handleAdditionalDriverAccidentPropChange(driverIndex, accidentIndex, 'wasAccidentSettled', e.target.value)}
              helpText=""
              dataBlock={generateDataBlockName('wasAccidentSettled')}
           />



        </div>
    );

}